function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M277.518-32.123c0-2.135 1.335-2.936 3.871-5.338 1.067-.934 2.4-2.136 3.6-2l6.673 9.873a3.939 3.939 0 0 1-2.669 3.2c-2.936 2.8 10.41 17.084 13.479 14.415a3.832 3.832 0 0 1 3.337-2.536l9.342 7.474c.134 1.2-1.2 2.4-2.269 3.47-2.536 2.269-3.47 3.6-5.605 3.47-10.541 1.738-32.162-21.617-29.759-32.028zM297.67-40c11.745.668 19.085 8.542 18.95 20.286 0 2.536-4 2.269-4 .534.267-10.01-5.739-16.416-15.75-16.95-1.735-.13-1.735-4 .8-3.87zm-.534 11.879c-1.735 0-2-3.737.4-3.737 6.94.133 11.211 4.8 10.944 11.744-.134 2.4-3.871 1.868-3.737.133.132-5.202-2.401-7.871-7.606-8.137z",
  transform: "translate(-277.333 40)"
});

var SvgContactPhone = function SvgContactPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39.289,
    height: 40,
    viewBox: "0 0 39.289 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContactPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contact_phone.b100d8ed.svg";
export { ForwardRef as ReactComponent };